import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory, Redirect } from 'react-router-dom';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import PpsiForm from '../components/PpsiForm';
import { Mode } from '../components/PpsiForm/constants';
import { getLanguage } from '../features/app/selectors';
import usePpsi from '../features/PpsiContainer/hooks/usePpsi';
import useCreateDraftPpsi from '../features/PpsiContainer/hooks/useCreateDraftPpsi';
import useUtensils from '../features/UtensilContainer/hooks/useUtensils';
import { ppsiInProgressRoute } from '../routes';
import usePpisRelatedToPpsi from '../features/PpiContainer/hooks/usePpisRelatedToPpsi';
import { useUnpublishPpsi } from '../features/PpsiContainer/hooks/usePpsiAction';
import View from './views';
import { fetchGlobalPpsi } from 'features/PpsiContainer/actions';
import { toJS } from 'utils/immutableUtils';
// import { getPpisAll } from 'features/PpiContainer/selectors';
import { getPpsiById } from 'features/PpsiContainer/selectors';
import useGlobalPublishedPpiIfs from '../features/PpsiContainer/hooks/useGlobalPublishedPpiIfs';
// import useGlobalPpis from 'features/PpiContainer/hooks/useGlobalPpis';
// import { getIsFetchingGlobal } from 'features/PpiContainer/selectors';

function getData(ppsi) {
  const data = ppsi.publishedPpsiEnrichmentData;
  const dish = data.referencedIFoodData;
  return {
    ...data,
    ppsiId: ppsi.id,
    dish
  };
}

const PpsiPublishedView = () => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [isFetchingPpsi, ppsi, fetchPpsiError] = usePpsi(id, {
    forceFetch: true
  });
  const [isFetchingRelatedPpis] = usePpisRelatedToPpsi(id);

  const [
    createDraftPpsi,
    isCreatingDraft,
    isCreateDraftDone
  ] = useCreateDraftPpsi();
  const [unpublishPpsi, isUnpublishing] = useUnpublishPpsi();
  const activeLanguage = useSelector(getLanguage);
  // const isFetchingGlobal = useSelector(getIsFetchingGlobal);
  const [glbalPpsiId, setGlobalPPsiId] = useState(null);
  const globalPpsi = useSelector(getPpsiById(glbalPpsiId));
  const [isFetchingGlobalPpiIfs, getGlobalId] = useGlobalPublishedPpiIfs();

  const prevParentPpsiIdRef = useRef(null);
  useEffect(() => {
    if (ppsi && ppsi.publishedPpsiEnrichmentData) {
      // console.log(ppsi.publishedPpsiEnrichmentData, 'first if');
      const newParentPpsiId = ppsi.publishedPpsiEnrichmentData.parentPpsiId;
      if (newParentPpsiId && newParentPpsiId !== prevParentPpsiIdRef.current) {
        // console.log(ppsi.publishedPpsiEnrichmentData, 'second if');
        setGlobalPPsiId(newParentPpsiId);
        dispatch(fetchGlobalPpsi(newParentPpsiId));
        prevParentPpsiIdRef.current = newParentPpsiId;
        getGlobalId(newParentPpsiId);
      }
    }
  }, [dispatch, ppsi]);

  const isFetching =
    isFetchingPpsi || isFetchingRelatedPpis || isFetchingGlobalPpiIfs;
  // || isFetchingGlobal;
  const fromPpsi = toJS(globalPpsi);
  useUtensils();

  if (fetchPpsiError) {
    throw fetchPpsiError;
  }
  if (isFetching || isCreatingDraft) {
    return <ProgressFullscreen open />;
  }
  if (isCreateDraftDone) {
    return <Redirect to={ppsiInProgressRoute(id)} />;
  }

  function handleEditInstruction() {
    const hasInProgressVersion = !!ppsi.inProgressPpsiEnrichmentData;
    if (hasInProgressVersion) {
      history.push(ppsiInProgressRoute(id));
    } else {
      createDraftPpsi(id);
    }
  }

  function handleUnpublish() {
    unpublishPpsi(id);
  }

  View.PpsiPublished.visit(ppsi, activeLanguage);
  // console.log(globalPpis, 'globalPpis');
  // Render form
  return (
    <PpsiForm
      data={getData(ppsi)}
      dataLabels={{
        title: (data, { language }) =>
          data.info &&
          data.info[language] &&
          data.info[language].presentationName,
        status: data => data.status,
        modifiedBy: 'lastModifiedBy',
        modifiedDate: 'modifyDate'
      }}
      showProgress={isUnpublishing}
      onCreateDraft={handleEditInstruction}
      onUnpublish={handleUnpublish}
      mode={Mode.READ}
      completePpsiData={ppsi}
      globalData={fromPpsi}
      // globalPpsis={globalPpsis}
      // globalPpis={globalPpis}
    />
  );
};

export default PpsiPublishedView;
